import type { SxProps, Theme } from '@mui/material/styles';

export const rowSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
};

export const modalContainerSx: SxProps<Theme> = {
  position: 'fixed',
  inset: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  p: 2,
};

export const modalCardSx: SxProps<Theme> = {
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',

  width: '512px',
  height: 'auto',

  p: '26px 33px',

  backgroundColor: '#111217',
  borderRadius: '14px',
  border: '1px solid rgba(255,255,255,0.1)',

  outline: 'none',
};

export const innerFrameSx: SxProps<Theme> = {
  width: '446px',
  height: 'auto',
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
};

export const headerRowSx: SxProps<Theme> = {
  ...rowSx,
  width: '446px',
  height: '40px',
  alignItems: 'center',
  justifyContent: 'space-between',
};

export const titleSx: SxProps<Theme> = {
  fontSize: 28,
  fontWeight: 'bold',
};

export const closeButtonSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '40px',
  height: '40px',
  p: 0,
};

export const actionsRowSx: SxProps<Theme> = {
  ...rowSx,
  gap: 2,
  '@media (max-width: 426px)': {
    flexDirection: 'column-reverse',
  },
};

export const primaryButtonSx: SxProps<Theme> = {
  width: '446px',
  height: '30px',
  borderRadius: '8px',
  border: '1px solid #FFFFFF1A',
  backgroundColor: '#354EEF',
  gap: '10px',
  opacity: 1,
  textTransform: 'none',
};